import i18n from "i18n/i18n";

function NotificationType(type: any, lang: string, plural = false) {
  type = Number(type);

  if (lang === "en") {
    if (type === 0) return plural ? "Malfunctions" : "Malfunction";
    if (type === 1) return plural ? "Abnormalities" : "Abnormality";
    if (type === 2) return plural ? "Memos" : "Memo";
    if (type === 3) return plural ? "Tasks" : "Task";
    if (type === 4) return plural ? "Internal Messages" : "Internal Message";
    if (type === 5)
      return plural ? "Manufacturer Messages" : "Manufacturer Message";
    if (type === 6)
      return plural ? "Planned Maintenances" : "Planned Maintenance";
    if (type === 7) return plural ? "Maintenances" : "Maintenance";
  } else {
    if (type === 0) return plural ? "Störungen" : "Störung";
    if (type === 1) return plural ? "Auffälligkeiten" : "Auffälligkeit";
    if (type === 2) return plural ? "Notizen" : "Notiz";
    if (type === 3) return plural ? "Aufgaben" : "Aufgabe";
    if (type === 4)
      return plural ? "Interne Mitteilungen" : "Interne Mitteilung";
    if (type === 5)
      return plural ? "Herstellermitteilungen" : "Herstellermitteilung";
    if (type === 6) return plural ? "Geplante Wartungen" : "Geplante Wartung";
    if (type === 7) return plural ? "Wartungen" : "Wartung";
  }
}

const NotificationTypeList = [
  [
    {
      name: "Malfunction",
      value: 0,
    },
    {
      name: "Abnormality",
      value: 1,
    },
    {
      name: "Memo",
      value: 2,
    },
    {
      name: "Task",
      value: 3,
    },
    {
      name: "Internal Message",
      value: 4,
    },
    {
      name: "Manufacturer Message",
      value: 5,
    },
    {
      name: "Planned Maintenance",
      value: 6,
    },
    {
      name: "Maintenance",
      value: 7,
    },
  ],

  [
    {
      name: "Störung",
      value: 0,
    },
    {
      name: "Auffälligkeit",
      value: 1,
    },
    {
      name: "Notiz",
      value: 2,
    },
    {
      name: "Aufgabe",
      value: 3,
    },
    {
      name: "Interne Mitteilung",
      value: 4,
    },
    {
      name: "Herstellermitteilung",
      value: 5,
    },
    {
      name: "Geplante Wartung",
      value: 6,
    },
    {
      name: "Wartung",
      value: 7,
    },
  ],
];

const NotificationStatusList = [
  [
    {
      name: "Open",
      value: 0,
    },
    {
      name: "In Progress",
      value: 1,
    },
    {
      name: "Closed",
      value: 2,
    },
  ],
  [
    {
      name: "Offen",
      value: 0,
    },
    {
      name: "In Bearbeitung",
      value: 1,
    },
    {
      name: "Erledigt",
      value: 2,
    },
  ],
];

function NotificationStatus(status: any, lang: string) {
  status = Number(status);

    if (status === 0) return i18n(lang).state_open;
    if (status === 1) return i18n(lang).state_in_discussion;
    if (status === 2) return i18n(lang).state_closed;

}

// TODO: retrieve standard maintenance categories from api OR
// TODO (@Daniel/Mathias): define appropriate maintenance categories and set up labels in context API
const StandardMaintenanceCategories = [
  { title: "Inspektion", value: "inspection", colorcode: "#8E24AA" },
  { title: "Hersteller", value: "manufacturer", colorcode: "#9E9E9E" },
];

export {
  NotificationStatus,
  NotificationType,
  NotificationTypeList,
  NotificationStatusList,
  StandardMaintenanceCategories,
};
